export default __webpack_public_path__ + "static/media/search.b829fab7.png";